export default __webpack_public_path__ + "static/10.03-3-b5a01300c88db07cf3946e65c8f65726.png";